import { createSelector } from 'reselect';
import { GlobalState } from '../rootReducer';
import { SET_SIGNIFYD_SESSION_ID } from './actions';

// reducer
const DEFAULT_STATE = {
    sessionId: '',
};

export type State = typeof DEFAULT_STATE;

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case SET_SIGNIFYD_SESSION_ID:
            return {
                ...state,
                sessionId: action.payload,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.signifyd;

export const getSignifydSessionId = createSelector(stateSelector, (state) => state.sessionId);

/* ACTION CREATORS */
export const saveSignifydSessionId = (sessionId: string) => ({
    payload: sessionId,
    type: SET_SIGNIFYD_SESSION_ID,
});
